import { I_OwnersForm } from "@/src-refactor/modules/shared/components/forms/create-owners-form/util/for.util";
import { C_YES_AND_NOT } from "@/src-refactor/modules/shared/model/const/yes-and-not.conts";
import dayjs from "dayjs";

const OwnerAdapterCreateUpdate = (x: I_OwnersForm) => {
  const removeGuion = (key: string): string => {
    if (typeof key === "string") {
      return key.replace(/-/g, "");
    } else {
      return "";
    }
  };

  const filter = (data: any) => {
    if (data && data.length >= 1) {
      return data;
    } else {
      return null;
    }
  };

  const data = {
    name: filter(x.name),
    identification: filter(removeGuion(x.number_identification)),
    identification_type: filter(x.identification_type[0].value),
    email: filter(x.email),
    birthdate: filter(dayjs(x.birthdate).format("YYYY/MM/DD")),
    mobile: filter(x.mobile_phone),
    phone: filter(x.phone),
    phone2: filter(x.residential_phone),
    fax: filter(x.fax),
    country: filter(x.country[0].label),
    city: filter(x.city),
    sector: filter(x.sector),
    address: filter(x.address),
    is_conflictive: filter(x.is_conflictive) ? 1 : 0
  };
  if (x.has_company[0].value !== C_YES_AND_NOT.NOT.value) {
    Object.assign(data, {
      company_name: filter(x.company),
      company_position: filter(x.company_occupation),
      company_identification: filter(x.company_identification),
      company_fax: filter(x.company_fax),
      company_email: filter(x.company_email),
      company_identification2: filter(x.company_registration_comercial)
    });
  }
  return data;
};

export { OwnerAdapterCreateUpdate };
